import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  canonical: string;
  noindex?: boolean;
}

function setMetaName(name: string, content: string): void {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setMetaProperty(property: string, content: string): void {
  let el = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

const DEFAULT_TITLE = "360PLUS | Industry-Born Construction Project Management";
const DEFAULT_CANONICAL = "https://360plusapp.com";

export function usePageMeta({ title, description, canonical, noindex = false }: PageMeta): void {
  useEffect(() => {
    document.title = title;
    setMetaName("description", description);
    setMetaName("robots", noindex ? "noindex, nofollow" : "index, follow");
    setMetaProperty("og:title", title);
    setMetaProperty("og:description", description);
    setMetaProperty("og:url", canonical);
    setCanonical(canonical);

    return () => {
      document.title = DEFAULT_TITLE;
      setCanonical(DEFAULT_CANONICAL);
      setMetaName("robots", "index, follow");
    };
  }, [title, description, canonical, noindex]);
}
